package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px

val ActivityFullWidthFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }
}


val ActivityHalfWidthFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val FormationFieldsStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.LG {
        Modifier
            .flexDirection(FlexDirection.Row)
            .columnGap(25.px)
            .rowGap(16.px)
    }
}

val FormationFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val ActivityFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .fillMaxWidth()
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val ActivityFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

val DropdownStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .minWidth(0.px)
    }
}

val CompetenceFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

val CompetenceFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.LG {
        Modifier
            .flexDirection(FlexDirection.Row)
            .columnGap(25.px)
            .rowGap(16.px)
    }
}

val CompetenceEqualFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val CompetenceLevelLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Light)
            .margin(bottom = 8.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val CourseFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

val CourseFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.LG {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Row)
            .columnGap(25.px)
            .rowGap(16.px)
    }
}

val CourseEqualFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .fillMaxWidth()
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

val CertificateFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier.gap(24.px)
    }
}

val CertificateFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.LG {
        Modifier
            .flexDirection(FlexDirection.Row)
            .columnGap(25.px)
            .rowGap(16.px)
    }
}

val CertificateEqualFieldStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}

